module.exports = __webpack_public_path__ + "img/18.e592cc60.png";